<template>
    <div>
        <van-tabs class="tabs_header" @click="changeActive" v-model="active">
            <template #nav-left>
                <van-icon @click="onClickLeft" name="arrow-left" /></template>
            <van-tab class="await-evaluate" title="待评价">

            </van-tab>
            <van-tab title="已评价">

            </van-tab>
        </van-tabs>

        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <div class="eva_content" v-if="active == 0">
                <ticket-scroll :url="'market-order/order-list'" :params="{type: 'un_comment'}" :text2="'暂无待评价的商品哦~'"
                    :emptyimg="true">
                    <template slot-scope="scope">
                        <div class="cards" v-for="(item, i) in scope.data" :key="i">
                            <div class="img-box">
                                <img :src="item.img_url" alt="" />
                            </div>
                            <div class="state">
                                <div class="title">{{ item.goods_name }}</div>
                                <div class="num">{{ item.detailInfo[0].gift_name }}</div>
                                <div class="btn">
                                    <p>
                                        <span class="doll">￥</span>
                                        <span class="price">{{ item.total_price }}</span>
                                    </p>
                                    <p class="cancelSc" @click="comment(item.detailInfo[0],item.order_num)">去评价</p>
                                </div>
                            </div>
                        </div>
                    </template>
                </ticket-scroll>
            </div>

            <div class="eva_content" v-else>
                <ticket-scroll :url="'market-order/order-list'" :params="{type: 'comment'}" :text2="'暂无已评价的商品哦~'"
                    :emptyimg="true">
                    <template slot-scope="scope">
                        <div class="evaluated" v-for="(item, i) in scope.data" :key="i">
                            <div class="times">
                                <span class="today">{{
                item.create_time.split(" ")[0].split("-")[1]
              }}</span>/{{ item.create_time.split(" ")[0].split("-")[2] }}月/{{
                item.create_time.split(" ")[0].split("-")[0]
              }}年
                            </div>
                            <div class="rate1">
                                <span>描述相符</span>
                                <van-rate v-model="item.evaluate_info.description_score" readonly />
                            </div>
                            <div class="rate2">
                                <span>物流服务</span>
                                <van-rate v-model="item.evaluate_info.logistics_score" readonly />
                            </div>
                            <div class="rate3">
                                <span>服务态度</span>
                                <van-rate v-model="item.evaluate_info.serve_score" readonly />
                            </div>
                            <div class="comment">
                                {{ item.evaluate_info.comment }}
                            </div>
                            <div class="real-img">
                                <img v-for="(imgitem, i) in item.evaluate_info.img.split(',')" :key="i" :src="imgitem"
                                    alt="" />
                            </div>
                            <div class="goods-card">
                                <div class="card-img">
                                    <img :src="item.img_url" alt="" />
                                </div>
                                <div class="card-state">
                                    <div>{{ item.goods_name }}</div>
                                    <div>{{ item.detailInfo[0].gift_name }}</div>
                                </div>
                            </div>
                        </div>
                    </template>
                </ticket-scroll>

            </div>
        </van-pull-refresh>
    </div>
</template>
<script>
    import api from '../Api'
    export default {
        mixins: [api],
        data() {
            return {
                active: 0,
                rate1: 4,
                rate2: 3,
                rate3: 5,
            };
        },
        created() {

        },
        mounted() {

        },
        methods: {
            changeActive(name, title) {
                this.active = name
            },
            //去评价
            comment(goods, order_num) {
                this.$RModal.publishComment({
                    selection: {
                        goodsinfo: goods,
                        order_num: order_num
                    },
                })
            }
        },
    };
</script>
<style lang="less" scoped>
    .eva_content {
        margin-top: 2.5rem;
        padding: .6rem .75rem;

        .cards {
            margin-bottom: .6rem;
            padding: 0.6rem;
            background-color: #ffffff;
            border-radius: 0.7rem;
            display: flex;

            .img-box {
                width: 3.75rem;
                height: 3.55rem;
                margin-right: 0.55rem;

                img {
                    border-radius: 0.7rem;
                    width: 100%;
                    height: 100%;
                }
            }

            .state {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .title {
                    font-size: 0.7rem;
                    color: #000000;
                    font-weight: bold;
                    width: 10.5rem;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .num {
                    color: #9e9e9e;
                    font-size: 0.6rem;
                }

                .btn {
                    display: flex;
                    justify-content: space-between;
                    align-items: end;

                    .doll {
                        font-size: 0.5rem;
                        color: #670000;
                    }

                    .price {
                        font-size: 0.8rem;
                        font-weight: bold;
                        color: #670000;
                    }

                    .cancelSc {
                        padding: 0.15rem 0.8rem;
                        background-color: #ecd7d5;
                        border-radius: 1rem;
                        font-size: 0.6rem;
                        color: #670000;
                    }
                }
            }
        }
    }

    .evaluated {
        margin-bottom: .6rem;
        padding: 0.45rem 0.6rem 1.1rem;
        background-color: #ffffff;
        border-radius: 0.7rem;

        .times {
            color: #000000;
            font-size: 0.6rem;
            font-weight: bold;
            margin-bottom: 0.75rem;

            .today {
                font-size: 1.1rem;
            }
        }

        .rate1,
        .rate2 {
            margin-bottom: 0.5rem;

            span {
                color: #656565;
                font-size: 0.6rem;
                margin-right: 0.35rem;
                margin-bottom: 0.5rem;
            }
        }

        .rate3 {
            margin-bottom: 0.65rem;

            span {
                color: #656565;
                font-size: 0.6rem;
                margin-right: 0.35rem;
            }
        }

        .comment {
            color: #000000;
            margin-bottom: 0.75rem;
        }

        .real-img {
            margin-bottom: 0.5rem;

            img {
                margin-right: 0.6rem;
                border-radius: 0.7rem;
                width: 4.55rem;
                height: 4.4rem;
            }
        }

        .goods-card {
            background-color: rgba(243, 242, 242, 0.77);
            display: flex;
            gap: 0.3rem;

            .card-img {
                width: 3.55rem;
                height: 3.3rem;

                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 0.7rem;
                }
            }

            .card-state {
                div:nth-child(1) {
                    color: #000000;
                    font-size: 0.6rem;
                    font-weight: bold;
                    margin-top: 0.7rem;
                    margin-bottom: 0.3rem;
                }

                div:nth-child(2) {
                    font-size: 0.6rem;
                    color: #9e9e9e;
                }
            }
        }
    }
</style>